import React, { createContext, useEffect, useState } from "react";
import { validateSession } from "../services/userServices";

const defaultState = {
  user: {},
  directivas: [],
  recursos: [],
};

export const AppContext = createContext(defaultState);

export const AppContextProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(false);
  const [user, setUser] = useState({});
  const [directivas, setDirectivas] = useState();
  const [recursos, setRecursos] = useState();
  const [isView, setIsView] = useState();
  const [notifications, setNotifications] = useState(0);
  const [count, setCount] = useState(0);
  const [tempPassword, setTempPassword] = useState(null); // en memoria, nunca en storage

  const appContextValue = {
    user,
    isLogged,
    directivas,
    recursos,
    isView,
    notifications,
    count,
    tempPassword,
    setIsLogged,
    setUser,
    setDirectivas,
    setRecursos,
    setIsView,
    setNotifications,
    setCount,
    setTempPassword,
  };

  useEffect(() => {
    validateSession(setIsLogged, setUser, setDirectivas, setRecursos,setIsView,setNotifications,setCount);
  }, []);

  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};
//export const AppContextProvider = AppContext.Provider
